import { Icon } from "@material-ui/core";
import Button from "Components/Common/Button/Button";
import Datepicker from "Components/Datepicker/Datepicker";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IApplicationState } from "Store/Store";
import { ITaskAction } from "Store/Tasks/TaskAction";
import { ITaskState } from "Store/Tasks/TaskState";
import i18n from "Translations/i18n";
import styles from "./ExportTasksPopup.scss";

const taskAction = ServiceProvider.get<ITaskAction>(Types.ITaskAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    exportTasksAsync: (fromDate: Date, toDate: Date) =>
        dispatch(taskAction.exportTasksAsync(fromDate, toDate)),
    close: () =>
        dispatch(taskAction.close())
});

const mapStateToProps = (state: IApplicationState) => ({
    taskState: state.taskState
});

interface IProps {
    shouldShow: boolean;
    taskState: ITaskState;
    exportTasksAsync: (fromDate: Date, toDate: Date) => Action;
    close: () => Action;
    onChange?: (state: { shouldShow: boolean }) => void;
}

interface IState {
    fromDate: Date;
    toDate: Date;
    hasDownloaded: boolean;
    shouldShow: boolean;
    isDownloading: boolean;
}

export class ExportTasksPopup extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        const today = new Date(new Date().setHours(0, 0, 0, 0));
        const fromDate = new Date(new Date(today).setFullYear(today.getFullYear() - 1));
        const toDate = new Date(today);

        this.state = {
            fromDate,
            toDate,
            hasDownloaded: false,
            shouldShow: props.shouldShow,
            isDownloading: false
        };

        this.onFromDateChanged = this.onFromDateChanged.bind(this);
        this.onToDateChanged = this.onToDateChanged.bind(this);
        this.export = this.export.bind(this);
        this.close = this.close.bind(this);
    }

    public onFromDateChanged(fromDate: Date) {
        this.setState({ fromDate });
    }

    public onToDateChanged(toDate: Date) {
        this.setState({ toDate });
    }

    public export() {
        this.setState({ isDownloading: true });
        this.props.exportTasksAsync(this.state.fromDate, this.state.toDate);
    }

    public close() {
        const today = new Date(new Date().setHours(0, 0, 0, 0));
        const fromDate = new Date(new Date(today).setFullYear(today.getFullYear() - 1));
        const toDate = new Date(today);

        this.setState({
            fromDate,
            toDate,
            hasDownloaded: false,
            shouldShow: false,
            isDownloading: false
        });

        if (this.props.onChange) {
            this.props.onChange({ shouldShow: false });
        }

        this.props.close();
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.shouldShow !== prevState.shouldShow) {
            partialState.shouldShow = nextProps.shouldShow;
        }

        if (nextProps.taskState.hasDownloaded !== prevState.hasDownloaded) {
            partialState.hasDownloaded = nextProps.taskState.hasDownloaded;
        }

        return partialState;
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.state.hasDownloaded !== prevState.hasDownloaded) {
            this.close();
        }
    }

    public render() {
        return (
            (this.state.shouldShow &&
                <div className={styles.overlay} onClick={this.close}>
                    <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.popupTitle}>
                            {i18n.t("tasks.exportTasks")}
                        </div>
                        <div className={styles.popupContent}>
                            <span>{i18n.t("common.from")}</span>
                            <Datepicker className={styles.datepicker} selectedDate={this.state.fromDate} onChange={this.onFromDateChanged} disabled={this.state.isDownloading} />
                            <span>{i18n.t("common.till")}</span>
                            <Datepicker className={styles.datepicker} selectedDate={this.state.toDate} onChange={this.onToDateChanged} disabled={this.state.isDownloading} />
                            <Button id="btnExportTasks" onClick={this.export} isLoading={this.state.isDownloading}>
                                <Icon>save_alt</Icon>
                                {i18n.t("tasks.exportTasks")}
                            </Button>
                            <Button id="btnCancelExport" onClick={this.close} disabled={this.state.isDownloading} >
                                {i18n.t("common.cancel")}
                            </Button>
                        </div>
                    </div>
                </div >
            )
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportTasksPopup);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverviewHeader/ExportTasksPopup/ExportTasksPopup.tsx